import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { goToSection } from '../navigation/goToSection';
import CalculatorCard from './CalculatorCard';
import HeroMessage from './HeroMessage';
import { CurvedEdge, Eyebrow, IconRow } from './ui';

// D3 = A: the promise and the way in on the left, the live calculator on the right.
// The globe moves to "Where you can send" in WU-4.
const Hero: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const points = [
    { icon: 'receipt' as const, title: t('hero.points.fee.title'), body: t('hero.points.fee.body') },
    { icon: 'currency' as const, title: t('hero.points.currency.title'), body: t('hero.points.currency.body') },
    { icon: 'phone' as const, title: t('hero.points.where.title'), body: t('hero.points.where.body') },
  ];

  return (
    <section id="home" className="band-teal hero" aria-label={t('hero.eyebrow')}>
      <div className="hero__inner">
        <div className="hero__copy">
          <Eyebrow>{t('hero.eyebrow')}</Eyebrow>
          <HeroMessage />
          <div className="hero__actions">
            <button
              type="button"
              className="btn btn--primary"
              onClick={() => goToSection('download', pathname, navigate)}
            >
              {t('hero.ctaPrimary')}
            </button>
            <button
              type="button"
              className="btn btn--outline-light"
              onClick={() => goToSection('calculator', pathname, navigate)}
            >
              {t('hero.ctaSecondary')}
            </button>
          </div>
          <IconRow tone="onDark" items={points} className="hero__points" />
        </div>
        <div className="hero__card">
          <CalculatorCard />
        </div>
      </div>
      <CurvedEdge position="bottom" fill="var(--paper)" />
    </section>
  );
};

export default Hero;
